export default __webpack_public_path__ + "static/media/leaderboard-colored.d4584b20.svg";